import ApiService from '@/common/api.service'
import * as action from '@/store/action.types'
import {
  GET_PAY_REPORTS_PDF_URL,
  GET_PAY_REPORTS_EXCEL_URL,
  GET_MSG_REPORTS_PDF_URL,
  GET_MSG_REPORTS_EXCEL_URL
} from '@/constants/ApiConstants'

const actions = {
  [action.GET_PAY_REPORTS_PDF]({ commit }, data) {
    return new Promise ( (resolve, reject) => {
      ApiService
        .post(GET_PAY_REPORTS_PDF_URL, data)
        .then(response => {
          return resolve(response)
        })
        .catch(error => {
          return reject(error)
        })
    })
  },
  [action.GET_PAY_REPORTS_EXCEL]({ commit }, data) {
    return new Promise ( (resolve, reject) => {
      ApiService
        .post(GET_PAY_REPORTS_EXCEL_URL, data)
        .then(response => {
          return resolve(response)
        })
        .catch(error => {
          return reject(error)
        })
    })
  },
  [action.GET_MSG_REPORTS_PDF]({ commit }, data) {
    return new Promise ( (resolve, reject) => {
      ApiService
        .post(GET_MSG_REPORTS_PDF_URL, data)
        .then(response => {
          return resolve(response)
        })
        .catch(error => {
          return reject(error)
        })
    })
  },
  [action.GET_MSG_REPORTS_EXCEL]({ commit }, data) {
    return new Promise ( (resolve, reject) => {
      ApiService
        .post(GET_MSG_REPORTS_EXCEL_URL, data)
        .then(response => {
          return resolve(response)
        })
        .catch(error => {
          return reject(error)
        })
    })
  }
}

export default {
  actions
}